module.exports = __webpack_public_path__ + "img/hide-password.d5e2dc64.svg";